import { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from '@givebutter/primitives/button';
import { faCog, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CreateEngageMessageParams } from 'api/engage';
import { GettingStarted as GettingStartedCards } from 'assets/js/pages/engage/GettingStarted';
import { MessageTemplateDialog } from 'assets/js/pages/engage/components/MessageTemplateDialog';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { EngageMessageChannel } from 'types/domain';

const EngageIndexTitle = () => {
    const { channel } = useParams<{ channel: EngageMessageChannel }>();
    return channel === 'email' ? 'Emails' : 'Texts';
};

const EngageIndexSettingsAction = () => {
    const { accountId } = useCurrentAccount();
    const { channel } = useParams<{ channel: EngageMessageChannel }>();
    const history = useHistory();

    const path = useMemo(() => {
        return channel === 'email'
            ? `/accounts/${accountId}/engage/settings/domains`
            : `/accounts/${accountId}/engage/settings/sms`;
    }, [channel, accountId]);

    return (
        <Button variant="outline" color="neutral" onClick={() => history.push(path)}>
            <FontAwesomeIcon icon={faCog} /> Settings
        </Button>
    );
};

interface EngageIndexTemplateDialogProps {
    onTemplateSelection: (data: CreateEngageMessageParams) => void;
}
const EngageIndexTemplateDialog = ({ onTemplateSelection }: EngageIndexTemplateDialogProps) => {
    const { channel } = useParams<{ channel: EngageMessageChannel }>();
    return (
        <MessageTemplateDialog channel={channel} onTemplateSelection={onTemplateSelection}>
            <Button variant="solid">
                <FontAwesomeIcon icon={faPlus} /> {channel === 'email' ? 'New email' : 'New text'}
            </Button>
        </MessageTemplateDialog>
    );
};
const EngageIndexGettingStarted = () => {
    const { channel } = useParams<{ channel: EngageMessageChannel }>();
    const {
        tasks: { engage: tasks },
    } = useCurrentAccount();

    const shouldRender = useMemo(() => {
        return (
            (channel === 'email' && (!tasks.has_branding || !tasks.has_domain)) ||
            (channel === 'sms' && !tasks.has_address)
        );
    }, [channel, tasks]);

    if (!shouldRender) return null;
    return (
        <div className="flex flex-col gap-4">
            <p className="text-xl font-medium">Getting started</p>
            <GettingStartedCards channel={channel} />
        </div>
    );
};

const Title = EngageIndexTitle;
const SettingsAction = EngageIndexSettingsAction;
const TemplateDialog = EngageIndexTemplateDialog;
const GettingStarted = EngageIndexGettingStarted;

export {
    Title,
    SettingsAction,
    TemplateDialog,
    GettingStarted,
    //
    EngageIndexTitle,
    EngageIndexSettingsAction,
    EngageIndexTemplateDialog,
    EngageIndexGettingStarted,
};
